<template>
	<div class="v-dobpicker" :class="classObject">
		<input type="text" v-model="displayDate" v-mask="mask" @keyup="changed">
		<button class="v-datepicker__clear" @click.prevent="clear" v-if="clearable">Clear</button>
	</div>
</template>
<script>
import moment from "moment";

export default {
	data() {
		return {
			displayDate: null,
		};
	},

	props: {
		dateFormat: {
			type: String,
			required: false,
			default() {
				return "YYYY-MM-DD";
			}
		},
		dateDisplayFormat: {
			type: String,
			required: false,
			default() {
				return "YYYY-MM-DD";
			}
		},

		clearable: {
			type: Boolean,
			default() {
				return true;
			}
		},
	},

	computed: {
		classObject() {
			return {
				"v-dobpicker--invalid": this.validDate === false,
			};
		},
		mask() {
			const regex = /[YMD]/ig;
			return this.dateDisplayFormat.replaceAll(regex, "#");
		},
		dateParts() {
			return this.displayDate?.split(/[\-\/]/);
		},
		validFormat() {
			return this.displayDate?.length === this.mask.length;
		},
		isoDate() {
			if (!this.validFormat) {
				return;
			}

			return [this.dateParts[2], this.dateParts[1], this.dateParts[0]].join("-");
		},
		day() {
			return this.isoDate?.split("-")[2];
		},
		month() {
			return this.isoDate?.split("-")[1];
		},
		year() {
			return this.isoDate?.split("-")[0];
		},
		dateObject() {
			if (!this.isoDate) {
				return null;
			}

			return new Date(this.isoDate);
		},
		dateObjectDay() {
			return String(this.dateObject?.getDate()).padStart(2, "0");
		},
		dateObjectMonth() {
			return String(this.dateObject?.getMonth() + 1).padStart(2, "0");
		},
		dateObjectYear() {
			return String(this.dateObject?.getFullYear());
		},
		validDate() {
			if (!this.dateObject) {
				return null;
			}

			return this.dateObjectDay === this.day &&
				this.dateObjectMonth === this.month &&
				this.dateObjectYear === this.year;
		},
		date: {
			get() {
				return this.$attrs.value;
			},
			set(date) {
				this.value = date;
				this.$emit("input", this.value);
				this.$emit("changed", this.value);
			}
		},
	},

	methods: {
		getDateFormat(display = false) {
			let dateFormat = !display ? this.dateFormat : this.dateDisplayFormat;
			let modeFormats = {
				date: dateFormat,
				dateTime: dateFormat + " HH:mm:ss",
				time: "HH:mm:ss",
			};

			return modeFormats[this.mode];
		},
		changed() {
			let date = moment(this.isoDate);

			if (!date.isValid()) {
				return;
			}

			this.date = date.format(this.dateFormat);
		},
		clear() {
			if (!this.clearable) {
				return;
			}

			this.date = "";
			this.displayDate = "";
		}
	},

	created() {
		if (!this.date) {
			return;
		}

		let date = moment(this.date, this.dateFormat);

		if (!date.isValid()) {
			return;
		}

		this.displayDate = date.format(this.dateDisplayFormat);
	}
};
</script>
